import { message, Radio } from 'antd';
import React, { useState } from 'react';
import * as S from '../../../components/ModalCentralizado/style';
import * as B from '../styles';
import { formatarCpfCnpj } from '../../../helpers/utils';

import {
  putFinalizarAtendimentoConsultaExterna
} from '../../../services';

export function ButtonFinalizarAtendimentoExterno({ funcOk, dadosMotorista }) {
  const [open, setOpen] = useState(false);
  const [valueRecomendacao, setValueRecomendacao] = useState(null);
  const [valueObservacoes, setValueObservacoes] = useState(null);

  const onChangeRecomendacao = e => {
    setValueRecomendacao(e.target.value);
  };

  const onChangeObservacoes = e => {
    setValueObservacoes(e.target.value);
  };

  const finalizar = async () => {
    const { response, error } = await putFinalizarAtendimentoConsultaExterna({ id: dadosMotorista.id, observacao: valueObservacoes, recomendada: valueRecomendacao === 1 });
    if (response) {
      setOpen(false);
      funcOk();
    } else if (error) {
      if (error?.response?.data?.status === 422 && error?.response?.data?.detail) {
        message.error(error?.response?.data?.detail);
      } else {
        message.error('Erro ao finalizar o atendimento da consulta externa. Tente novamente!');
      }
    }
  };

  return (
    <>
      <B.ButtonGrid type="primary" onClick={() => setOpen(true)}>
        Finalizar
      </B.ButtonGrid>
      <S.ModalCentralizada
        footer={null}
        centered
        onClick={() => setOpen(true)}
        open={open}
        onCancel={() => setOpen(false)}
      >
        <S.ContentModal>
          <S.Title>Finalize o atendimento</S.Title>
        </S.ContentModal>
        <S.ContentModal>
          <S.InfoModal
            fontWeight="bold"
          >
            {`${formatarCpfCnpj(dadosMotorista?.cpf || '')} - ${dadosMotorista?.nome || ''}`}
          </S.InfoModal>
        </S.ContentModal>
        <S.ContentModal>
          <S.InfoModal>Observações</S.InfoModal>
        </S.ContentModal>
        <S.TextAreaModal
          id="observacoes"
          showCount={true}
          maxLength={40000}
          autoFocus
          autoSize={{ minRows: 6, maxRows: 12 }}
          placeholder="Digite aqui"
          onChange={onChangeObservacoes}
        />
        <S.ContentModal>
          <Radio.Group
            name="recomendacao"
            onChange={onChangeRecomendacao}
            defaultValue={0}
          >
            <S.OptionRadio value={1}>Recomendado</S.OptionRadio>
            <S.OptionRadio value={2}>Não recomendado</S.OptionRadio>
          </Radio.Group>
        </S.ContentModal>
        <S.ContainerButtons>
          <S.ButtonCustom
            type="primary"
            size="large"
            disabled={!((valueObservacoes || '').length > 0 && valueRecomendacao > 0)}
            onClick={() => finalizar()}
          >
            Finalizar
          </S.ButtonCustom>
        </S.ContainerButtons>
      </S.ModalCentralizada>
    </>
  );
}
